import { TextField, Select, Button, Typography, Checkbox, FormControlLabel, MenuItem, FormControl, InputLabel } from "@mui/material";
import { OrderFields } from "./OrderFields";
import { checkBar } from "../../../../Services/Api";
import useSound from "use-sound";
import err from '../../sounds/err.mp3';

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from 'dayjs';
import { useDebounce, useLocalStorageState } from "../lib";
import { useMutation } from "@tanstack/react-query";


export const MainForm = (props) => {
  const {
    stage,
    date,
    setDate,
    barCode,
    setBarCode,
    order,
    setOrder,
    boxSize,
    setBoxSize,
    mainFormState,
    setMainFormState,
    fullReset,
    autocomplete,
    setAutocomplete,
    withoutAgregation,
    setWithoutAgregation,
    aggLevelId,
    setAggLevelId,
  } = props;
  const [playErr] = useSound(err);
  const [aggrVar, setAggrVar] = useLocalStorageState('aggrVar', []);


  const mutation = useMutation({
    mutationKey: ['checkBar', barCode],
    mutationFn: checkBar,
    onSuccess: (data) => {
      // console.log('!!!checkBar data', data)
      if (data?.result === "OK") {
        if (Array.isArray(data?.payload))
          setAggrVar(data.payload)
        // setRezult(aggrCode, data?.payload?.productName || data?.payload?.produktName);
      } else {
        setBarCode('')
        playErr();
      }
      console.log('!!!Code check successful:', data?.payload?.status);
    },
    onError: (error) => {
      playErr();
      // console.error('!!!Code check failed:', error);
      // clear();
      // setErrorMessage(error?.message ? (`Сетевая ошибка: ${error.message}`) : 'Непредвиденная сетевая ошибка');
    },
  });
  useDebounce(barCode, 500, (value) => {
    if (value) {
      mutation.mutate({ barCode: value })
    }
  })

  const setAggrLevelHandler = (levelId) => {
    // console.log('!!!levelId', levelId)
    setAggLevelId(levelId);
    const bs = aggrVar.find(({aggLevelId})=>aggLevelId===levelId)?.boxSize
    if(bs) setBoxSize(bs);
  }

  return (
    <div>
      <div style={{ display: "flex", marginTop: "5px" }}>
        <div style={{ margin: "0 10px" }}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label="Штрих-код артикула"
            size="small"
            value={barCode}
            onChange={(e) => setBarCode(e?.target?.value || e)}
            disabled={mainFormState !== 'edit'}
          />
        </div>
        <div style={{ margin: "0 10px" }}>
          <TextField
            InputLabelProps={{ shrink: true }}
            label="Количество в коробке"
            size="small"
            value={boxSize}
            onChange={(e) => setBoxSize(e?.target?.value || e)}
            disabled={mainFormState !== 'edit'}
          />
        </div>
        {/* </div>
      <div style={{ display: "flex" }}> */}

        <div style={{ margin: "0 10px" }}>
          <DatePicker
            InputLabelProps={{ shrink: true }}
            label="Дата выпуска"
            views={['year', 'month', 'day']}
            slotProps={{
              textField: {
                size: 'small', // Делает поле компактным, как у обычного TextField
              },
            }}
            value={date ? dayjs(date) : null}
            onChange={(newValue) => {
              if (newValue && newValue.isValid()) {
                setDate(newValue.format('YYYY-MM-DD'));
              } else {
                setDate(null); // Если поле очистили
              }
            }}
            disabled={mainFormState !== 'edit'}
          />
        </div>
        <div style={{ margin: "0 10px" }}>
          <FormControl variant="outlined" sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="order-label">Уровень агрегации</InputLabel>
            <Select
              sx={{ m: 1, minWidth: 120 }}
              labelId="order-label"
              id="order"
              value={aggLevelId}
              size="small"
              disabled={mainFormState !== 'edit'}
              label="Уровень агрегации"
              onChange={(e)=>setAggrLevelHandler(e.target.value || e)}
            >
              {aggrVar.map(({ label, aggLevelId }) => (<MenuItem value={aggLevelId}>{label}</MenuItem>))}
            </Select>
          </FormControl>
        </div>
        <div style={{ margin: "0 10px" }}>
          {/* <Select size="small">

          </Select> */}
          <OrderFields
            value={order}
            onChange={setOrder}
            disabled={mainFormState !== 'edit'} />
          {/* <TextField
            InputLabelProps={{ shrink: true }}
            label="Номер заказа"
            size="small"
            value={order}
            onChange={(e) => setOrder(e?.target?.value || e)}
            disabled={mainFormState !== 'edit'}
          /> */}
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <div style={{ margin: "0 10px" }}>
          <FormControlLabel
            control={<Checkbox
              checked={autocomplete}
              onChange={(e) => setAutocomplete(e.target.checked)}
              disabled={mainFormState !== 'edit'}
            />}
            label="Автоматическая отправка финального кода подтверждения (третий шаг система выполнит автоматически)"
          />
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <div style={{ margin: "0 10px" }}>
          <FormControlLabel
            control={<Checkbox
              checked={withoutAgregation}
              onChange={(e) => setWithoutAgregation(e.target.checked)}
              disabled={mainFormState !== 'edit'}
            />}
            label="Агрегационный код не требуется"
          />
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <div style={{ margin: "0 10px" }}>
          {mainFormState === 'edit' ? (
            <Button onClick={() => setMainFormState('saved')} variant="contained">Сохранить</Button>
          ) : (stage === "1" ? (

            <Button onClick={() => setMainFormState('edit')} variant="contained">Редактировать</Button>
          ) : (
            <Button onClick={() => {
              window.confirm('Подтвердите что хотите сбросить результаты сканирования и вернуться на первый этап') && fullReset()
            }} color="error" variant="contained">Сбросить и редактировать</Button>

          )
          )}
        </div>

      </div>
      <Typography variant="h6" gutterBottom>{mainFormState === 'edit' ? 'Заполнение исходных данных' : 'Заполнение рабочих данных'}</Typography>
      {mainFormState === 'edit' ? (
        <Typography variant="body1">
          Внесите (отсканируйте) артикул, внесите количество товара в упаковке, внесите дату изготовления,
          и номер заказ, затем нажмите кнопку "Сохранить"
        </Typography>
      ) : (
        <Typography variant="body1" gutterBottom>
          При необходимости изменения артикула, количество товара, даты изготовления - нажмите кнопку Редактировать
        </Typography>
      )}

    </div>
  )

}